export default "__VITE_ASSET__901bad1b__"